import { CHANNEL } from '../../../../../features/templates/constants/messageTemplateKeys';

export const TEMPLATE_TABS = [
  { key: CHANNEL.EMAIL, label: 'Email Templates' },
  { key: 'text', label: 'Text Templates' },
];

export function tabKeyFromChannels(channels) {
  const set = new Set((channels ?? []).map(String));
  if (set.size === 0 || set.has(CHANNEL.EMAIL)) return CHANNEL.EMAIL;
  if (set.has(CHANNEL.SMS) || set.has(CHANNEL.MMS)) return 'text';
  return CHANNEL.EMAIL;
}

export function channelsForTabKey(tabKey) {
  return tabKey === 'text' ? [CHANNEL.SMS, CHANNEL.MMS] : [CHANNEL.EMAIL];
}
